import React from "react";
import PropTypes from "prop-types";
import Moment from "moment";
import { useSelector } from "react-redux";
import { getFormattedEventDate } from "@qgiv/core-js";
import { ThemeType } from "../../../../../redux/constants";
import { selectHTTP } from "../../../../../redux/slices/configSlice";
import { selectAllP2pSettings } from "../../../../../redux/slices/p2pSettingsSlice";
import { selectSpecificFormSetting } from "../../../../../redux/slices/formSettingsSlice";
import { selectThemeSettings } from "../../../../../redux/slices/cmsSettingsSlice";
import RegistrationHeader from "./RegistrationHeader";

const ConnectedRegistrationHeader = ({ isMediumScreen = false }) => {
    const HTTP_HOST = useSelector(selectHTTP);
    const { startDate, endDate, timezone, alias } =
        useSelector(selectAllP2pSettings);
    const title = useSelector((state) =>
        selectSpecificFormSetting(state, "title"),
    );
    const themeSettings = useSelector((state) =>
        selectThemeSettings(ThemeType.HEADER, state),
    );
    const {
        regHeaderSettings: {
            displayEventDate = true,
            pageHeading = "Register for %EventName%",
            additionalText = "",
        },
    } = themeSettings;

    const eventHomeUrl = `${HTTP_HOST}/event/${alias}/`;

    // since %EventName% is required in pageHeading, can make this required prop
    const renderHeading = () => (
        <h1 className="-text--center">
            {pageHeading.split("%EventName%")[0]}
            <a href={eventHomeUrl} target="_blank" rel="noreferrer">
                {title}
            </a>
            {pageHeading.split("%EventName%")[1]}
        </h1>
    );

    const formattedDateString = getFormattedEventDate({
        startDate,
        endDate,
        timezone,
    });

    const momentStartDate = Moment(startDate);
    const momentEndDate = Moment(endDate);
    const isSameDay = momentStartDate.isSame(momentEndDate, "day");
    const hasStartDate = momentStartDate.isValid();
    const hasEndDate = momentEndDate.isValid() && !isSameDay;
    const hasDate = hasStartDate || hasEndDate;
    const registrationHeaderProps = {
        additionalText,
        displayEventDate,
        formattedDateString,
        hasDate,
        isMediumScreen,
        renderHeading,
    };

    return <RegistrationHeader {...registrationHeaderProps} />;
};

ConnectedRegistrationHeader.propTypes = {
    isMediumScreen: PropTypes.bool.isRequired,
};

export default ConnectedRegistrationHeader;
